<template>
  <div v-if="$store.state.user" class="confidentialite compteTab">
    <div>
      <h2>Profils bloqués</h2>
      <p>
        Vous pouvez cliquer su le bouton ci-dessous pour consulter la liste des profils que vous avez bloqués. Si vous
        souhaitez débloquer un profil, il suffit de retirer ce profil de la liste en cliquant sur la petite croix
        présente en haut à droit de l'encart du profil.
      </p>
      <router-link class="bouton" :to="{ name: 'Blacklist' }">Profils bloqués</router-link>
    </div>
    <div>
      <h2>Informations de connexion</h2>
      <div v-if="serenity" class="simpleForm invert">
        <div>
          <input
            id="status"
            v-model="$store.state.profile.status"
            :true-value="1"
            :false-value="0"
            type="checkbox"
            @change="updateStatus"
          />
        </div>
        <div>
          <label for="status"> Je souhaite apparaître hors ligne même lorsque je suis connecté(e). </label>
        </div>
      </div>
      <div class="simpleForm invert">
        <div>
          <input
            id="last"
            v-model="$store.state.profile.hideLastConnection"
            :true-value="true"
            :false-value="false"
            type="checkbox"
            @change="updateLast"
          />
        </div>
        <div>
          <label for="last"> Je souhaite masquer ma date de dernière connexion aux autres membres. </label>
        </div>
      </div>
    </div>
    <div v-if="hasPass">
      <h2 class="histo">Mode sécurisé</h2>
      <input
        @change="updateSecureMode"
        type="checkbox"
        id="secureMode"
        name="secureMode"
        v-model="$store.state.user.secureMode"
        :true-value="true"
        :false-value="false"
      />
      <label for="secureMode"> Je souhaite uniquement communiquer avec les membres disposant d'un Pass Idylive. </label>
      <p class="italic">
        Lorsque vous cochez cette case, vous ne verrez plus les messages et les profils des membres n'ayant pas de Pass
        Idylive. Nous ne pouvons pas garantir à 100% que cela éliminera tous les profils d'escroquerie mais cela devrait
        très fortement réduire leur présence.
      </p>
    </div>
    <div v-if="serenity">
      <h2>Filtre de contacts</h2>
      <div class="simpleForm invert">
        <div>
          <input id="filter" :checked="hasFilter" type="checkbox" @change="toggleFilter" />
        </div>
        <div>
          <label for="filter"> Activer le filtre de contacts. </label>
        </div>
      </div>
      <div class="form" v-if="hasFilter">
        <div class="label">
          <label>Sexe</label>
        </div>
        <div class="value">
          <select v-model="filter.sex" @change="updateFilter">
            <option value="0">
              Indifférent
            </option>
            <option value="FEMALE">
              Femme
            </option>
            <option value="MALE">
              Homme
            </option>
          </select>
        </div>
        <div class="label">
          <label>Son âge</label>
        </div>
        <div class="value">
          De
          <select v-model="filter.ageMin" class="age" @change="updateFilter">
            <option v-for="i in 82" :key="i + 17" :value="i + 17">
              {{ i + 17 }}
            </option>
          </select>
          à
          <select v-model="filter.ageMax" class="age" @change="updateFilter">
            <option v-for="i in 82" :key="i + 17" :value="i + 17">
              {{ i + 17 }}
            </option>
          </select>
          ans
        </div>
        <div class="label">
          <label>Son pays</label>
        </div>
        <div class="value">
          <select v-model="filter.id_country" @change="countryChange">
            <option :value="0">
              Tous
            </option>
            <option v-for="data in countries" :key="data.id" :value="data.id">
              {{ data.name }}
            </option>
          </select>
        </div>

        <div class="label">
          <label>Sa région</label>
        </div>
        <div class="value">
          <select v-model="filter.id_region" :disabled="regions.length === 0" @change="updateFilter">
            <option :value="0">
              Toutes
            </option>
            <option v-for="data in regions" :key="data.id" :value="data.id">
              {{ data.name }}
            </option>
          </select>
        </div>
        <div class="label">
          <label>Sa photo</label>
        </div>
        <div class="value check">
          <select v-model="filter.withPicture" @change="updateFilter">
            <option :value="false">
              Indifférent
            </option>
            <option :value="true">
              Avec photo uniquement
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { idyu_hasSerenity } from "@/assets/js/idyu/util.js";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import { idyu_hasPass } from "../../assets/js/idyu/util";

export default {
  name: "Confidentialite",
  data: function() {
    return {
      filter: null,
      countries: [],
      regions: []
    };
  },

  methods: {
    updateSecureMode: function() {
      idyuJsonRpc("setSecureMode", this.$store.state.user.secureMode);
      this.$store.state.needsReload = true;
    },

    updateStatus: function() {
      idyuJsonRpc("setAppearOffline", this.$store.state.profile.status !== 0);
    },

    updateLast: function() {
      idyuJsonRpc("setHideLastConnection", this.$store.state.profile.hideLastConnection);
    },

    toggleFilter: async function() {
      let newState = !this.hasFilter;
      let wasNull = this.filter == null;
      await idyuJsonRpc("setContactFilter", newState);
      if (wasNull) {
        this.filter = await idyuJsonRpc("getContactFilter");
      }
      this.filter.activated = newState;
      this.$store.state.needsReload = true;
    },

    updateRegions: async function() {
      this.regions = await idyuJsonRpc("getRegions", this.filter.id_country);
    },

    countryChange: function() {
      if (this.filter) {
        this.filter.id_region = 0;
        this.updateRegions();
        this.updateFilter();
      }
    },

    init: async function() {
      if (this.serenity) {
        this.countries = await idyuJsonRpc("getCountries");
        this.filter = await idyuJsonRpc("getContactFilter");
        if (this.filter) {
          await this.updateRegions();
        }
      }
    },

    updateFilter: function() {
      this.filter.className = "search.CContactFilter";
      idyuJsonRpc("updateContactFilter", this.filter);
      this.$store.state.needsReload = true;
    },

    countryChanged: function() {}
  },

  computed: {
    serenity: function() {
      return idyu_hasSerenity(this.$store.state.user.pass.permission);
    },

    hasFilter: function() {
      return this.serenity && this.filter != null && this.filter.activated;
    },

    hasPass: function() {
      return idyu_hasPass(this.$store.state.user.pass.permission) && this.sale;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";
@import "@/assets/css/forms.scss";
@import "@/assets/css/compte.scss";

select.age {
  width: auto !important;
}

.form {
  max-width: 500px;
}

.italic {
  font-style: italic;
}
</style>
